export default {
  namespaced: true,
  state: {
    rawData: [],
    data: [],
    selectedCategory: '',
    selectedSubCategory: '',
    selectedSubSubCategory: '',
    selectedSubSubCategoryId: ''
  },
  getters: {
    // subCategories: state => {
    //   return state.data.reduce((categories, category) => [...categories, ...category.subCategories], [])
    // }
    subCategory: state => level => {
      if (state.rawData.length) {
        return state.rawData.filter(el => el.level === level)
      } else return null
    },
    categoryName: state => {
      if (state.selectedCategory && state.selectedSubCategory && state.selectedSubSubCategory) {
        const db = state.data.find(category => category.code === state.selectedCategory)
        if (!db) return false
        const table = db.subCategories.find(category => category.code === state.selectedSubCategory)
        if (!table) return false
        return table.name
      } else return false
    },
    subCategories: state => routeParams => {
      const db = state.data?.find(category => category.code === routeParams.db)
      if (!db) return {}
      const table = db.subCategories.find(category => category.code === routeParams.table)
      const subTable = table?.subCategories.find(category => category.code === routeParams.subtable)

      return { db, table, subTable }
    },
    isRemovable: state => {
      return state.rawData.find(el => el.level === 2 && el.code === state.selectedSubSubCategory)?.removable
    }
  },
  mutations: {
    setRawData (state, payload) {
      if (payload.rawData) {
        state.rawData = payload.rawData
        state.rawData.sort((a, b) => b.level - a.level)
      }
    },
    setData (state) {
      const data = []

      state.rawData.reduce((categories, category) => {
        categories[category.code] = {
          id: category.id,
          name: category.name,
          code: category.code
        }
        if (category.child_codes.length > 0) {
          categories[category.code].subCategories = category.child_codes.map(childCode => ({
            parent: category.code,
            ...categories[childCode]
          }))
        }
        if (category.level === 0) data.push(categories[category.code])
        return categories
      }, {})

      state.data = data
    },
    setCategory (state, payload) {
      state.selectedCategory = payload.code
    },
    setSubCategory (state, payload) {
      state.selectedSubCategory = payload.code
    },
    setSubSubCategory (state, payload) {
      if (payload.code && payload.code.includes('-')) {
        const data = payload.code.split('-')
        state.selectedSubSubCategory = data[1]
        state.selectedSubSubCategoryId = data[0]
      }
    }
  },
  actions: {
    getIdByCode ({ state }, { code, level }) {
      if (level) {
        return state.rawData.find(el => el.level === level && el.code === code)?.id
      } else return state.data.find(el => el.code === code)?.id
    },
    getPartCategories ({ rootState, state, commit }) {
      return new Promise((resolve, reject) => {
        fetch(`${rootState.api.host}${rootState.api.endpoint.part_categories}`, {
          headers: {
            Authorization: 'Bearer ' + rootState.user.accesToken
          }
        })
          .then(response => response.json())
          .then(data => {
            commit('setRawData', { rawData: data.part_categories })
            commit('setData')
            commit('setCategory', { code: state.data[0]?.code })
            resolve()
          })
          .catch(error => reject(error))
      })
    },
    async getPartCategory ({ rootState }, id) {
      return await fetch(`${rootState.api.host}${rootState.api.endpoint.part_categories}/${id}`, {
        headers: {
          Authorization: 'Bearer ' + rootState.user.accesToken
        }
      }).then(r => r.json()).then(data => data.part_category)
    },
    setCategories ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit('setCategory', { code: payload.db })
        commit('setSubCategory', { code: payload.table })
        commit('setSubSubCategory', { code: payload.subtable })
        resolve()
      })
    }
  }
}
